<wissenswerft-companies-card-list [title]="dataService.res('Ubt-TreeList-Companies')" 
    [navigateUrl]="navigateUrlPath" [companyIdDependency]="companyIdDependency"
    [companyNameDependency]="companyNameDependency" [configDependencies]="configDependencies"
    [filterOptions]="filterOptions" (filterData)="prepareFiltredData($event)" (clickProject)="clickProject($event)"
    (clickCompany)="clickCompany($event)" (selectLastProjectUpdated)="selectLastProjectUpdated($event)">
</wissenswerft-companies-card-list>